<div class="p-t-5 p-b-5"
     *ngIf="true">
    <ng-container [ngSwitch]="type">
        <ng-container *ifSize="'SM'">
            <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
        </ng-container>
        <div class="flex flex-middle">
            <!-- filter by -->
            <div class="h4 col-1 m-r-2">
                <button class="button-3 button-size-1 w-12"
                        (click)="showFiltersModal()">{{'Filter' | translate}}</button>
            </div>

            <div class="w-12 flex flex-justify-between flex-middle"
                 *ngSwitchCase="'bulkOrder'">
                <!-- count of results -->
                <div *ifSize="'!S'"
                     class="m-r-10 p1 col-11 no-wrap flex flex-middle">
                    <ng-container *ifSize="'!M'">
                        <ng-container *ngTemplateOutlet="selectedFilters"></ng-container>
                    </ng-container>
                    {{ (getTotal === 1 ? '% Product' : '% Products') | translate : getTotal }}
                </div>

                <ng-container *ifSize="'LX'">
                    <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
                </ng-container>

                <div>
                    <!-- sort options -->
                    @if(bulkOrdersortOutlet?.inputs?.sort) {
                    <ng-container *ngComponentOutlet="
                            bulkOrdersortOutlet.component;
                            inputs: bulkOrdersortOutlet.inputs;
                          " />
                    }
                    @if(sizeOutlet?.inputs?.size) {
                    <ng-container *ngComponentOutlet="
                                    sizeOutlet.component;
                                    inputs: sizeOutlet.inputs;
                                    " />
                    }

                </div>
            </div>

            <ng-container *ngSwitchDefault>
                <ng-container *ifSize="'!SM'">
                    <!-- sort options -->
                    @if(sortOutlet.inputs?.sort) {
                    <ng-container *ngComponentOutlet="
                                        sortOutlet.component;
                                        inputs: sortOutlet.inputs;
                                        " />
                    }


                    <ng-container *ngTemplateOutlet="selectedFilters"></ng-container>
                </ng-container>

                <!-- hfill -->
                <div class="flex-grow"></div>

                <span class="p1 col-12 m-r-10 p-r-6 no-wrap"
                      *ifSize="'!SM'">
                    {{ (getTotal === 1 ? '% Product' : '% Products') | translate : getTotal }}
                </span>
                <div class="flex"
                     [style.font-size.em]="app.client.isS ? 1.42 : 1.6">
                    <div class="inline-block va-m">
                        <ng-container *ngComponentOutlet="
                                            sizeOutlet?.component;
                                            inputs: sizeOutlet.inputs
                                            " />
                    </div>

                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ifSize="'SM'">
        <ng-container *ngTemplateOutlet="selectedFilters"></ng-container>
    </ng-container>

    <!-- count of results mobile -->
    <div class="col-11 m-b-0 m-t-3"
         [tradeClass]="'c-5 !flex !flex-bottom'"
         *ifSize="'S'">
        <div [tradeClass]="'flex-grow'"
             [ngClass]="type === 'bulkOrder' ? 'p2' : 'p1'">
            {{ (getTotal === 1 ? '% Product' : '% Products') | translate : getTotal }}
        </div>
    </div>
</div>



<!-- Selected filters -->
<ng-template #selectedFilters>
    <div class="flex flex-wrap m-r-2">
        @for (filter of filtersWithSelection; track $index) {
        @if((['stock', 'attribute-option'].includes(filter.config?.type) || filter.filterType === 'ac-filter') &&
        !noResults) {
        @switch(filter.filterType) {
        @default {
        @for(optionId of filter.selection; track $index) {
        <button class="no-wrap col-12">
            <i class="inline-flex m-l-3 m-l-0-m m-l-0-s p-a-2 icon-close"
               [style.font-size.em]="0.8"
               (click)="filter.unselect(optionId)"></i>
            <span class="inline-block p-t-2 p-b-2 p1 no-wrap">
                <span class="capitalize">{{filter.attribute.data.label}}&nbsp;-&nbsp;</span>
                {{filter.getOptionLabel(optionId)}}
                &nbsp;|&nbsp;{{filter.matchesCountsCurrent[optionId]}}</span>
        </button>
        }
        }
        @case ('attribute-range') {
        <i class="inline-flex m-l-3 m-l-0-m m-l-0-s p-a-2 icon-close"
           [style.font-size.em]="0.8"
           (click)="filter.reset()"></i>
        <span class="inline-block p-t-2 p-b-2 p1">
            <ng-container *ngIf="filter.selection.min">
                {{ 'from' | translate }} <price [value]="filter.selection.min"></price>
            </ng-container>
            <ng-container *ngIf="filter.selection.max">
                {{ 'to' | translate }} <price [value]="filter.selection.max"></price>
            </ng-container>
        </span>
        }
        @case ('ac-filter') {
        <button class="no-wrap col-12">
            <i class="inline-flex m-l-3 m-l-0-m m-l-0-s p-a-2 icon-close"
               [style.font-size.em]="0.8"
               (click)="filter.unselect(filter.filterProp,filter.optionProp)"></i>
            <span class="inline-block p-t-2 p-b-2 p1 no-wrap">
                <span class="capitalize">{{filter.label}}&nbsp;-&nbsp;</span>
                {{filter.value}}
                &nbsp;|&nbsp;{{filter.matchesCount}}</span>
        </button>
        }
        }
        }
        }
    </div>
</ng-template>

<ng-template #noResultInfo>
    <ng-container *ifTradeStore>
        <ng-container *ngIf="noResults">
            <icms-outlet-block name="No result"
                               variant="no-result">
            </icms-outlet-block>
        </ng-container>
    </ng-container>
</ng-template>
